module.exports = __webpack_public_path__ + "static/media/Global_Combined.afb46187.png";